import { PredefinedColors } from '@ionic/core';

export const getButtonColorFromControlIcon = (
  icon?: string
): PredefinedColors => {
  switch (icon) {
    case 'insert':
      return 'success';
    case 'edit':
      return 'warning';
    case 'delete':
      return 'danger';
    default:
      return 'dark';
  }
};
